export default [
    {label: 'American Light Lager'},
    {label: 'American Lager'},
    {label: 'Cream Ale'},
    {label: 'American Wheat Beer'},
    {label: 'International Pale Lager'},
    {label: 'International Amber Lager'},
    {label: 'International Dark Lager'},
    {label: 'Czech Light Lager'},
    {label: 'Czech Pilsner'},
    {label: 'New England Style IPA'},
    {label: 'Czech Amber Lager'},
    {label: 'Czech Dark Lager'},
    {label: 'Munich Helles'},
    {label: 'Festbier'},
    {label: 'Helles Bock'},
    {label: 'German Leichtbier'},
    {label: 'Kolsch'},
    {label: 'German Exportbier'},
    {label: 'German Pils'},
    {label: 'Marzen'},
    {label: 'Rauchbier'},
    {label: 'Dunkels Bock'},
    {label: 'Vienna Lager'},
    {label: 'Altbier'},
    {label: 'Kellerbier'},
    {label: 'Kellerbier: Munich Kellerbier'},
    {label: 'Kellerbier: Franconian Kellerbier'},
    {label: 'Munich Dunkel'},
    {label: 'Schwarzbier'},
    {label: 'Doppelbock'},
    {label: 'Eisbock'},
    {label: 'Baltic Porter'},
    {label: 'Weissbier'},
    {label: 'Dunkels Weissbier'},
    {label: 'Weizenbock'},
    {label: 'Ordinary Bitter'},
    {label: 'Best Bitter'},
    {label: 'Strong Bitter'},
    {label: 'English Golden Ale'},
    {label: 'Australian Sparkling Ale'},
    {label: 'English IPA'},
    {label: 'Dark Mild'},
    {label: 'English Brown Ale'},
    {label: 'English Porter'},
    {label: 'Scottish Light'},
    {label: 'Scottish Heavy'},
    {label: 'Irish Red Ale'},
    {label: 'Irish Stout'},
    {label: 'Irish Extra Stout'},
    {label: 'Sweet Stout'},
    {label: 'Oatmeal Stout'},
    {label: 'Tropical Stout'},
    {label: 'Foreign Export Stout'},
    {label: 'English Strong Ale'},
    {label: 'Old Ale'},
    {label: 'Wee Heavy'},
    {label: 'English Barleywine'},
    {label: 'Blonde Ale'},
    {label: 'American Pale Ale'},
    {label: 'American Amber Ale'},
    {label: 'California Common'},
    {label: 'American Brown Ale'},
    {label: 'American Porter'},
    {label: 'American Stout'},
    {label: 'Russian Imperial Stout'},
    {label: 'American IPA'},
    {label: 'Specialty IPA'},
    {label: 'Specialty IPA: Black IPA'},
    {label: 'Specialty IPA: Brown IPA'},
    {label: 'Specialty IPA: White IPA'},
    {label: 'Specialty IPA: Rye IPA'},
    {label: 'Specialty IPA: Belgian IPA'},
    {label: 'Specialty IPA: Red IPA'},
    {label: 'Double IPA'},
    {label: 'American Strong Ale'},
    {label: 'American Barleywine'},
    {label: 'Wheatwine'},
    {label: 'Berliner Weisse'},
    {label: 'Flanders Red Ale'},
    {label: 'Oud Bruin'},
    {label: 'Lambic'},
    {label: 'Gueuze'},
    {label: 'Fruit Lambic'},
    {label: 'Witbier'},
    {label: 'Belgian Pale Ale'},
    {label: 'Biere de Garde'},
    {label: 'Belgian Blond Ale'},
    {label: 'Saison'},
    {label: 'Belgian Golden Strong Ale'},
    {label: 'Trappist Single'},
    {label: 'Belgian Dubbel'},
    {label: 'Belgian Tripel'},
    {label: 'Belgian Dark Strong Ale'},
    {label: 'Historical Beer: Gose'},
    {label: 'Historical Beer: Pivo Grodziskie'},
    {label: 'Historical Beer: Lichtenhainer'},
    {label: 'Historical Beer: Roggenbier'},
    {label: 'Historical Beer: Sahti'},
    {label: 'Historical Beer: Kentucky Common'},
    {label: 'Historical Beer: Pre-Prohibition Lager'},
    {label: 'Historical Beer: Pre-Prohibition Porter'},
    {label: 'Historical Beer: London Brown Ale'},
    {label: 'Brett Beer'},
    {label: 'Mixed Fermentation Sour Beer'},
    {label: 'Soured Fruit Beer'},
    {label: 'Fruit Beer'},
    {label: 'Fruit and Spice Beer'},
    {label: 'Speciality Fruit Beer'},
    {label: 'Spice, Herb, or Vegetable Beer'},
    {label: 'Autumn Seasonal Beer'},
    {label: 'Winter Seasonal Beer'},
    {label: 'Alternative Grain Beer'},
    {label: 'Alternative Sugar Beer'},
    {label: 'Classic Style Smoked Beer'},
    {label: 'Specialty Smoked Beer'},
    {label: 'Wood-Aged Beer'},
    {label: 'Specialty Wood-Aged Beer'},
    {label: 'Clone Beer'},
    {label: 'Mixed-Style Beer'},
    {label: 'Experimental Beer'}
]